export default "__VITE_ASSET__BH_OGDb9__"